"use strict";
/*
 * Created on Fri Jul 20 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AdtFlag_1 = require("../../core/model/AdtFlag");

var utils_1 = require("../../core/utils");
/**
 * Product flag is related to {@link Product internal product}. Multiple product flagSet
 * can be related to one product.
 *
 * @author Stepan Mik
 */
// tslint:disable:max-classes-per-file


var ProductFlag =
/*#__PURE__*/
function (_AdtFlag_1$AdtFlag) {
  _inherits(ProductFlag, _AdtFlag_1$AdtFlag);

  function ProductFlag() {
    _classCallCheck(this, ProductFlag);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductFlag).apply(this, arguments));
  }

  _createClass(ProductFlag, null, [{
    key: "register",
    value: function register(ctor, tag) {
      return AdtFlag_1.AdtFlag.registerBase(ProductFlag, ctor, tag);
    }
  }, {
    key: "deserialize",
    value: function deserialize(data) {
      return AdtFlag_1.AdtFlag.deserializeBase(ProductFlag, data);
    }
  }]);

  return ProductFlag;
}(AdtFlag_1.AdtFlag);

exports.ProductFlag = ProductFlag;
ProductFlag.TAG = '__ProductFlag__';
/**
 * Denotes that product with this flag is an item leader within line (products with same ratio) of particular family. Leading
 * product is typically calculated automatically (within task), but it can be also set manually by user. Further more, some changes
 * applied to family (and other influenced families) can trigger recalculation of leader within specific family and line. Rules for
 * determining family leader are:
 *      – When new family is created:
 *          – Within family creation, some products already assigned to a family can be assign to newly created. If any of those products
 *            was item leader, recalculation must be performed for family (or families) and particular line (or lines) for its original
 *            family.
 *          – For newly created family is always performed recalculation for all its lines.
 *      – When change of size ratio of product is done:
 *          – If product was leader within original line, recalculation of original line and also new one is done.
 *          – If product was not leader within original line, no recalculation is done.
 *      – When product is assigned to family or unassigned from family:
 *          – If product had no family and there is opened release, no recalculation is done.
 *          – If product assigned to family was not leader in previous one, recalculation of only targeted line within given family is done.
 *          – If product assigned to family was leader in previous one, recalculation of original line and targeted line is done.
 *          – If unassigned product from family was leader, recalculation of that line is done.
 *      – When leader has been set manually by user, there is one exception for previous use case:
 *          – If product assigned to family was not leader in previous and leader of targeted line was set by user, no recalculation is
 *            done.
 */

var LeadingProduct =
/*#__PURE__*/
function (_ProductFlag) {
  _inherits(LeadingProduct, _ProductFlag);

  /**
   * @param setByUser flag indicating whether product was chosen as leader manually by user
   */
  function LeadingProduct(setByUser) {
    var _this;

    _classCallCheck(this, LeadingProduct);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LeadingProduct).call(this));
    _this.setByUser = setByUser;
    return _this;
  }

  _createClass(LeadingProduct, [{
    key: "validate",
    value: function validate() {
      return !utils_1.Utils.isValueMissing(this.setByUser);
    }
  }]);

  return LeadingProduct;
}(ProductFlag);

exports.LeadingProduct = LeadingProduct;
LeadingProduct.TAG = ProductFlag.register(LeadingProduct);
/**
 * Denotes that product with this flag is weighted (e.g. for transaction, sales and supply, respectively)
 */

var WeightedProduct =
/*#__PURE__*/
function (_ProductFlag2) {
  _inherits(WeightedProduct, _ProductFlag2);

  function WeightedProduct() {
    _classCallCheck(this, WeightedProduct);

    return _possibleConstructorReturn(this, _getPrototypeOf(WeightedProduct).apply(this, arguments));
  }

  _createClass(WeightedProduct, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return WeightedProduct;
}(ProductFlag);

exports.WeightedProduct = WeightedProduct;
WeightedProduct.TAG = ProductFlag.register(WeightedProduct);
/**
 * Flag indicating that product is seasonal. Seasonality is not typically over the whole year, a product will be marked by
 * this flag only if currently is.
 */

var SeasonalProduct =
/*#__PURE__*/
function (_ProductFlag3) {
  _inherits(SeasonalProduct, _ProductFlag3);

  function SeasonalProduct() {
    _classCallCheck(this, SeasonalProduct);

    return _possibleConstructorReturn(this, _getPrototypeOf(SeasonalProduct).apply(this, arguments));
  }

  _createClass(SeasonalProduct, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return SeasonalProduct;
}(ProductFlag);

exports.SeasonalProduct = SeasonalProduct;
SeasonalProduct.TAG = ProductFlag.register(SeasonalProduct);

var NewProduct =
/*#__PURE__*/
function (_ProductFlag4) {
  _inherits(NewProduct, _ProductFlag4);

  function NewProduct(newProduct, requiresConfiguration) {
    var _this2;

    _classCallCheck(this, NewProduct);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(NewProduct).call(this));
    _this2.newProduct = newProduct;
    _this2.requiresConfiguration = requiresConfiguration;
    return _this2;
  }

  _createClass(NewProduct, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return NewProduct;
}(ProductFlag);

exports.NewProduct = NewProduct;
NewProduct.TAG = ProductFlag.register(NewProduct);
/**
 * The product with this flag has taken over the price architecture settings of its predecessor.
 */

var RecommendedProduct =
/*#__PURE__*/
function (_ProductFlag5) {
  _inherits(RecommendedProduct, _ProductFlag5);

  function RecommendedProduct(tierId, familyId) {
    var _this3;

    _classCallCheck(this, RecommendedProduct);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(RecommendedProduct).call(this));
    _this3.tierId = tierId;
    _this3.familyId = familyId;
    return _this3;
  }

  _createClass(RecommendedProduct, [{
    key: "validate",
    value: function validate() {
      return this.tierId !== undefined || this.familyId !== undefined;
    }
  }]);

  return RecommendedProduct;
}(ProductFlag);

exports.RecommendedProduct = RecommendedProduct;
RecommendedProduct.TAG = ProductFlag.register(RecommendedProduct);
/**
 * Product price related flag. Products with this flag cannot be repriced.
 */

var FixedPriceProduct =
/*#__PURE__*/
function (_ProductFlag6) {
  _inherits(FixedPriceProduct, _ProductFlag6);

  function FixedPriceProduct() {
    _classCallCheck(this, FixedPriceProduct);

    return _possibleConstructorReturn(this, _getPrototypeOf(FixedPriceProduct).apply(this, arguments));
  }

  _createClass(FixedPriceProduct, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return FixedPriceProduct;
}(ProductFlag);

exports.FixedPriceProduct = FixedPriceProduct;
FixedPriceProduct.TAG = ProductFlag.register(FixedPriceProduct);
/**
 * Product price related flag. Products with this flag cannot be repriced.
 */

var BlockedProduct =
/*#__PURE__*/
function (_ProductFlag7) {
  _inherits(BlockedProduct, _ProductFlag7);

  function BlockedProduct() {
    _classCallCheck(this, BlockedProduct);

    return _possibleConstructorReturn(this, _getPrototypeOf(BlockedProduct).apply(this, arguments));
  }

  _createClass(BlockedProduct, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return BlockedProduct;
}(ProductFlag);

exports.BlockedProduct = BlockedProduct;
BlockedProduct.TAG = ProductFlag.register(BlockedProduct);
/**
 * <p>
 *     Product price related flag. The entry, cheapest point to the price structure of a certain part of the assortment. In most cases these
 *     are private labels. For instance, it can be milk, which is private label of the company, which has the lowest price within its tier
 *     and which is typically paired with concurrent product, which is also private label.
 * </p>
 *
 * <p>
 *     Description may be extended with respect to margin etc.
 * </p>
 */

var FirstPricePoint =
/*#__PURE__*/
function (_ProductFlag8) {
  _inherits(FirstPricePoint, _ProductFlag8);

  function FirstPricePoint() {
    _classCallCheck(this, FirstPricePoint);

    return _possibleConstructorReturn(this, _getPrototypeOf(FirstPricePoint).apply(this, arguments));
  }

  _createClass(FirstPricePoint, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return FirstPricePoint;
}(ProductFlag);

exports.FirstPricePoint = FirstPricePoint;
FirstPricePoint.TAG = ProductFlag.register(FirstPricePoint);
/**
 * Flag indicating that product is so called private label. Product can have only one private label flag.
 */

var PrivateLabel =
/*#__PURE__*/
function (_ProductFlag9) {
  _inherits(PrivateLabel, _ProductFlag9);

  /**
   * @param title the title of private label
   */
  function PrivateLabel(title) {
    var _this4;

    _classCallCheck(this, PrivateLabel);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(PrivateLabel).call(this));
    _this4.title = title;
    return _this4;
  }

  _createClass(PrivateLabel, [{
    key: "validate",
    value: function validate() {
      return !utils_1.Utils.isValueMissing(this.title);
    }
  }]);

  return PrivateLabel;
}(ProductFlag);

exports.PrivateLabel = PrivateLabel;
PrivateLabel.TAG = ProductFlag.register(PrivateLabel);
/**
 * Flag indicating that product cannot be used (in any matter) within sellout releases.
 */

var SelloutRestricted =
/*#__PURE__*/
function (_ProductFlag10) {
  _inherits(SelloutRestricted, _ProductFlag10);

  function SelloutRestricted() {
    _classCallCheck(this, SelloutRestricted);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutRestricted).apply(this, arguments));
  }

  _createClass(SelloutRestricted, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return SelloutRestricted;
}(ProductFlag);

exports.SelloutRestricted = SelloutRestricted;
SelloutRestricted.TAG = ProductFlag.register(SelloutRestricted);
/**
 * Flag indicating that product is for stands - systemVolume = promoPrice = regularPrice = 0.
 */

var StandProduct =
/*#__PURE__*/
function (_ProductFlag11) {
  _inherits(StandProduct, _ProductFlag11);

  function StandProduct() {
    _classCallCheck(this, StandProduct);

    return _possibleConstructorReturn(this, _getPrototypeOf(StandProduct).apply(this, arguments));
  }

  _createClass(StandProduct, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return StandProduct;
}(ProductFlag);

exports.StandProduct = StandProduct;
StandProduct.TAG = ProductFlag.register(StandProduct);
/**
 * Flag indicating that product is in a campaign. It is used to identify returnable items.
 */

var Campaign =
/*#__PURE__*/
function (_ProductFlag12) {
  _inherits(Campaign, _ProductFlag12);

  function Campaign() {
    _classCallCheck(this, Campaign);

    return _possibleConstructorReturn(this, _getPrototypeOf(Campaign).apply(this, arguments));
  }

  _createClass(Campaign, [{
    key: "validate",
    value: function validate() {
      return true;
    }
  }]);

  return Campaign;
}(ProductFlag);

exports.Campaign = Campaign;
Campaign.TAG = ProductFlag.register(Campaign); // If a new new product flag is added, add it also to packages/pricing-dp-ahold/src/reports/model/ProductExportDTO.ts.